import axios from 'axios';
import Cookies from 'js-cookie';
import { api, headers } from '../../app/conf';
import { getDomain, isTokenExpired } from '../helpers';

// The access token kept in Redux comes from redux-persist and can be stale:
// omuni-web and the 401 interceptor both refresh the shared session cookie,
// but the store is only synced from it on mount. The cookie is the source of
// truth, so the heartbeat reads the token from there on every tick.
const getSession = () => {
    try {
        const raw = Cookies.get('session', { domain: getDomain() });
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export const heartbeatService = () => {
    const session = getSession();
    const accessToken = session?.accessToken;

    // With no usable token there is nothing to report: a 401 does not keep the
    // session alive, it only burns the SIC availability budget. Skip this tick
    // and try again on the next one, once a refresh has renewed the cookie.
    if (!accessToken || isTokenExpired(accessToken) || isTokenExpired(session?.refreshToken)) {
        return Promise.resolve(null);
    }

    return axios({
        method: 'post',
        url: `${api}/keep-alive`,
        data: {},
        headers: {
            ...headers,
            'access-token': accessToken
        }
    });
};
